import React from 'react';
import JSONLD from 'react-structured-data/dist/JSONLD';
import AggregateRating from 'react-structured-data/dist/schemas/AggregateRating';

export default function(props) {
  return (
    <JSONLD dangerouslyExposeHtml>
      <AggregateRating bestRating={5} {...props} />
    </JSONLD>
  );
}
